module.exports = __webpack_public_path__ + "static/img/banner_1.ac874f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner/banner_1.gif
// module id = EPtB
// module chunks = 2